export const LINE_HEIGHT = 19
export const INLINE_LINES = 12
export const INLINE_HEIGHT = INLINE_LINES * LINE_HEIGHT
export const EDITOR_WIDTH = 480
export const TOOLBAR_HEIGHT = 33
